// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from "@material-ui/core/styles/makeStyles";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import TimerIcon from '@material-ui/icons/Timer';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import DeleteIcon from '@material-ui/icons/Delete';
import type { Zone } from '../../../types';
import ConfirmDialog from '../../ui/ConfirmDialog';
import DurationUntil from '../../ui/Duration/DurationUntil';

const useStyles = makeStyles(theme => ({
    time: {
        whiteSpace: 'nowrap',
        fontFamily: '"Roboto Mono", monospace',
        letterSpacing: '-0.5px'
    },
    iconButton: {
        padding: 0,
        marginLeft: '.5ch'
    },
    minWidthCell: {
        width: 1
    },
    timerIcon: {
        marginRight: 3,
        color: theme.palette.text.secondary,
        verticalAlign: 'bottom'
    }
}));

export type Props = $ReadOnly<{
    zone: Zone,
    selected: boolean,

    onClick: (zone: Zone) => void,
    onLocateClick: (zone: Zone) => void,
    onSelect: (id: string, selected: boolean) => void,
    onDelete: (id: string) => void
}>;

function ZoneListItem({ zone, selected, onClick, onLocateClick, onSelect, onDelete }: Props) {
    const classes = useStyles();

    const onCheckboxClick = (e) => {
        e.stopPropagation();
    };

    const onChange = (e) => {
        e.preventDefault();
        e.stopPropagation();

        onSelect(zone.id, !selected);
    };

    const handleClick = (e) => {
        e.preventDefault();
        onClick(zone);
    };

    const handleLocateClick = () => onLocateClick(zone);

    const handleDelete = () => onDelete(zone.id);

    const durationTimestamp = (zone.active && zone.activeUntil) ? zone.activeUntil.seconds * 1000 : null;

    return (
        <TableRow
            hover
            onClick={handleClick}
        >
            <TableCell padding="none" className={classes.minWidthCell}>
                <Checkbox
                    checked={selected}
                    onClick={onCheckboxClick}
                    onChange={onChange}
                />
            </TableCell>
            <TableCell scope="row" padding="none">
                {zone.name}
            </TableCell>
            <TableCell scope="row" padding="none" className={classes.minWidthCell} style={{ whiteSpace: 'nowrap' }}>
                <TimerIcon fontSize="small" className={classes.timerIcon}/> <DurationUntil timestamp={durationTimestamp} />
            </TableCell>
            <TableCell scope="row" padding="none" className={classes.minWidthCell}>
                <IconButton size="small" onClick={handleLocateClick} className={classes.iconButton}>
                    <GpsFixedIcon fontSize="small" />
                </IconButton>
            </TableCell>
            <TableCell scope="row" padding="none" className={classes.minWidthCell}>
                <ConfirmDialog
                    title={(
                        <FormattedMessage
                            id="zones.deleteConfirmation"
                            defaultMessage="Are you sure you want to delete this zone?"
                        />
                    )}
                    stopPropagation
                    onConfirm={handleDelete}
                >
                    {(openDialog) => (
                        <IconButton size="small" onClick={openDialog}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    )}
                </ConfirmDialog>
            </TableCell>
        </TableRow>
    );
}

export default ZoneListItem;